import { render, staticRenderFns } from "./successNetpayView.vue?vue&type=template&id=4db64362&"
import script from "./successNetpayView.vue?vue&type=script&lang=js&"
export * from "./successNetpayView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "successNetpayView.vue"
export default component.exports